var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"popup_button_ok popup_button_ok-freespins"},[_c('div',{staticClass:"popup_button_ok-freespins-box",on:{"click":_vm.onCloseClick}},[_c('DefaultButton',{attrs:{"text":_vm.text}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }